import {
    formatDateTimeLong,
    formatTime,
    minutesToDuration,
} from '~/lib/DateTime.js';
import { SelectionImage } from '~/components/forms/questions/components/SelectionBlock.jsx';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import SeriesTime from '~/components/forms/questions/scheduling/SeriesTime';
import ClassDescription, {
    ClassSpotsLeft,
    ClassTitle,
    isInstanceSelected,
} from '~/components/forms/questions/scheduling/ClassDescription';
import ClassBookButton from '~/components/forms/questions/scheduling/ClassBookButton';
import { clientFormatTime } from '~/public/lib/ClientDateTime.js';

const ClassRow = ({
    instance,
    isFirst,
    onSelect,
    onRemove,
    settings,
    isSelected,
    clientTz,
}) => {
    const type = instance.event_type;

    return (
        <div className={`${!isFirst ? 'border-t' : ''} py-4 flex-1 pr-6`}>
            <div className="flex">
                {!!type.image && (
                    <SelectionImage image={type.image} className="my-0 mt-0" />
                )}
                <div>
                    <div>
                        {clientFormatTime(instance.start, clientTz)}
                        {!settings?.hideDuration && (
                            <> · {minutesToDuration(type.duration)}</>
                        )}
                    </div>
                    <ClassTitle type={type} settings={settings} />
                </div>
                {/*<div className="flex-1 flex items-start justify-between">*/}
                {/*    <div className="sm:flex items-start">*/}
                {/*        {!!type.image && (*/}
                {/*            <SelectionImage*/}
                {/*                image={type.image}*/}
                {/*                className="my-0 mt-0"*/}
                {/*            />*/}
                {/*        )}*/}
                {/*        <ClassDescription*/}
                {/*            instance={instance}*/}
                {/*            type={type}*/}
                {/*            className="hidden sm:block"*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <ClassDescription instance={instance} type={type} className="" />
            <div className="flex items-center min-w-24 mt-2">
                <ClassBookButton
                    instance={instance}
                    onSelect={onSelect}
                    onRemove={onRemove}
                    isSelected={isSelected}
                    settings={settings}
                />

                <ClassSpotsLeft
                    instance={instance}
                    settings={settings}
                    className="ml-2"
                />
            </div>
        </div>
    );
};

const ClassList = ({
    classes,
    settings,
    onSelectClass,
    onRemoveClass,
    selectedClasses,
    clientTz,
}) => {
    return (
        <div className="bg-white rounded-lg pl-6 mt-4">
            {classes.map((i, idx) => (
                <ClassRow
                    key={i.id}
                    isFirst={idx === 0}
                    instance={i}
                    settings={settings}
                    isSelected={isInstanceSelected(i, selectedClasses)}
                    onSelect={() => onSelectClass(i)}
                    onRemove={() => onRemoveClass(i)}
                    clientTz={clientTz}
                />
            ))}
        </div>
    );
};

export default ClassList;
